import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { ButtonWithIcon } from '@ff-os/shared-react/components/buttons/button-with-icon/ButtonWithIcon';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { selectHaveAnyPhotosBeenAdded } from '../../../_redux-groups';
import styles from './EmptyPhotoPrintsGroup.module.scss';

const _EmptyPhotoPrintsGroup = ({ haveAnyPhotosBeenUploaded, openUploadMethods }: Props) => {
    const { t } = useTranslation();
    return (
        <div className={styles.container}>
            {haveAnyPhotosBeenUploaded ? (
                <p className={styles.text}>
                    <Trans i18nKey='photo_prints.drag_or_upload'>
                        Drag photos from another group or
                        <span onClick={openUploadMethods} className={styles.emptyGroupCta}>
                            upload new photos
                        </span>.
                    </Trans>
                </p>
            ) : (
                <>
                    <ButtonWithIcon strokeWidth={2} icon='alert-circle-plus' onClick={openUploadMethods}>
                        {t('photo_prints.add')}
                    </ButtonWithIcon>
                    <p className={styles.noPhotos}>
                        {t('photo_prints.no_photos')}
                    </p>
                </>
            )}
        </div>
    );
};

type Props = {
    haveAnyPhotosBeenUploaded: boolean;
    openUploadMethods: () => void;
};

const mapStateToProps = (state: PhotoPrintsPdpState) => ({
    haveAnyPhotosBeenUploaded: selectHaveAnyPhotosBeenAdded(state)
});

export const EmptyPhotoPrintsGroup = connect(
    mapStateToProps
)(_EmptyPhotoPrintsGroup);